import { defineStore } from 'pinia'
import axios from 'axios'

const API_URL = '/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token'),
    user: null
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token
  },
  
  actions: {
    async login(credentials) {
      try {
        const response = await axios.post(`${API_URL}/login`, credentials)
        this.token = response.data.access_token
        localStorage.setItem('token', this.token)
        
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        
        await this.fetchUser()
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Login failed' 
        }
      }
    },
    
    async register(userData) {
      try {
        const response = await axios.post(`${API_URL}/register`, userData)
        return { success: true, user: response.data }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Registration failed' 
        }
      }
    },
    
    async changePassword(passwordData) {
      try {
        const response = await axios.put(`${API_URL}/me/password`, passwordData)
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Password change failed' 
        }
      }
    },
    
    async fetchUser() {
      try {
        const response = await axios.get(`${API_URL}/me`)
        this.user = response.data
      } catch (error) {
        this.logout()
      }
    },
    
    logout() {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      
      // Use window.location to navigate to login page
      window.location.href = '/login'
    },
    
    initializeAuth() {
      if (this.token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        this.fetchUser()
      }
    }
  }
})